import styled from "styled-components";

export const LabelText = styled.span`
  position: absolute;
  left: 0px;
  padding: 5px;
`